import React from 'react';
import GlideComponent from 'components/carousel/GlideComponent';
import { connectURL } from 'constants/defaultValues';
import { NavLink } from 'react-router-dom';

const slideItems = [
  {
    icon: '/assets/img/cards/insight.svg',
    title: 'AI Insights',
    detail:
      'WellPay leverages modern AI to generate industry data in real-time, giving you instant access to today’s most crucial total rewards insights.',
  },
  {
    icon: '/assets/img/cards/strategy.svg',
    title: 'Compensation Strategy',
    detail:
      'Seamlessly plan and execute your broad-based, sales, and executive compensation strategies with data-driven resources that make it easy to meet your goals.',
  },
  {
    icon: '/assets/img/cards/speed.svg',
    title: 'High-Speed Implementation',
    detail:
      'WellPay users are able to create a compensation design and implement their updated strategies in as little as 3 months, less than half the time of traditional total rewards programs.',
  },
  {
    icon: '/assets/img/cards/leading.svg',
    title: 'Leading Expertise',
    detail:
      'Created by industry-leading total rewards & data science executives, our platform is here to help departments of every size create competitive compensation plans at scale.',
  },
];

const slideSettings = {
  type: 'carousel',
  gap: 30,
  perView: 4,
  hideNav: true,
  peek: { before: 10, after: 10 },
  breakpoints: {
    600: { perView: 1 },
    992: { perView: 2 },
    1200: { perView: 3 },
  },
};

function Hero({ scrollTo, refRowHome, refSectionHome }) {
  return (
    <div className="section home" ref={refSectionHome}>
      <div className="container">
        <div className="row home-row" ref={refRowHome}>
          <div className="col-12 d-block d-md-none">
            <NavLink to="/">
              <img
                alt="mobile hero"
                className="mobile-hero"
                src="/assets/img/landing-page/landing-page-hero.webp"
              />
            </NavLink>
          </div>

          <div className="col-12 col-xl-4 col-lg-5 col-md-6">
            <div className="home-text">
              <h1 className="display-1">
                Redefine What It Means To Pay Well
              </h1>
              <p className="white mb-5">
                WellPay is an AI-powered compensation and total rewards service
                that gives HR teams the insights and analysis they need to
                attract and retain top talent, reduce turnover, and create
                thriving workplaces.
              </p>
              {/* eslint-disable-next-line react/jsx-no-target-blank */}
              <a
                className="btn btn-light btn-xl mr-2 mb-2"
                href={connectURL}
                target="_blank"
              >
                Tell us what you need <i className="simple-icon-arrow-right" />
              </a>
            </div>
          </div>
          <div className="col-12 col-xl-7 offset-xl-1 col-lg-7 col-md-6  d-none d-md-block">
            {/* eslint-disable-next-line react/jsx-no-target-blank */}
            <a
              href={connectURL}
              target="_blank"
              aria-label="Talk to us about what you need"
            >
              <img
                style={{ maxWidth: '100%' }}
                alt="hero"
                src="/assets/img/landing-page/landing-page-hero.webp"
              />
            </a>
          </div>
        </div>
        <h2 className="display-1 text-center text-white font-bold">
          Welcome To WellPay
        </h2>
        <div className="row">
          <div className="col-12 p-0">
            <div className="home-carousel">
              <GlideComponent settings={slideSettings}>
                {slideItems.map((f, index) => (
                  <div key={`slide_${index}`} className="card">
                    <div className="card-body text-center">
                      <div>
                        <img
                          className="large-icon"
                          src={f.icon}
                          alt={f.title}
                        />
                        <h5 className="mb-3 font-weight-semibold">{f.title}</h5>
                      </div>
                      <div>
                        <p className="detail-text">{f.detail}</p>
                      </div>
                    </div>
                  </div>
                ))}
              </GlideComponent>
            </div>
          </div>
        </div>
        <div className="d-flex py-5 justify-content-center">
          {/* eslint-disable-next-line react/jsx-no-target-blank */}
          <a className="btn btn-light btn-xl" href={connectURL} target="_blank">
            Talk to us <i className="simple-icon-arrow-right" />
          </a>
        </div>
        <div className="row">
          <a
            className="btn btn-circle btn-outline-semi-light hero-circle-button"
            href="#scroll"
            onClick={(event) => scrollTo(event, 'features')}
          >
            <i className="simple-icon-arrow-down" />
          </a>
        </div>
      </div>
    </div>
  );
}

export default Hero;
